myaccountHandler = {
    $btnViewDetails       : $('.btn-view-details'),
    $contentBillAddress   : $('.content-billing-address-edit'),
    $contentShipAddress   : $('.content-shipping-address-edit'),
    $editAccountForm      : $('.edit-account-form'),
    $cellEditAccountForm  : $('.cell-edit-account-form'),
    $btnPaymentMethod     : $('.btn-payment-method'),
    $accordionOpenContent : $('.accordion-open-content'),

    handlerEvents: function(){
        let self = this;

        $(document).on('click', '.btn-view-details', function(e){
            let $parent = $(this).closest('.woocommerce-orders-table__row');
            $parent.find('.accordion-title').click();
            $(this).toggleClass('is-active');
        });

        this.$btnPaymentMethod.on('click', function(e){
            e.preventDefault();
            self.$accordionOpenContent.click();
            $(this).toggleClass('opened');
        });

        $(document).on('click', '[href="#btn-edit-address"], [href="#btn-edit-account"]', function(e){
            e.preventDefault();
            let type    = $(this).data('type');
            let $form   = (type == 'billing') ? self.$contentBillAddress : self.$contentShipAddress; 
            let $iframeBody = $form.children().get(0).contentWindow.document.body;
            let height  = $iframeBody.scrollHeight + 100;
            let $parent = $(this).closest('.woocommerce-Addresses');
            $($form.children().get(0).contentWindow.document.children[0]).addClass('no-scrollbar');
            
            if (type) {
                $parent.toggleClass('edit-'+type);
                productHandler.wcSetSelectUI();
                if (!$parent.hasClass('edit-'+type)) {
                    height = 0;
                }
            } else {
                $form  = self.$cellEditAccountForm;
                height = self.$editAccountForm.outerHeight() + 100;
                $(this).toggleClass('opened');
                if (!$(this).hasClass('opened')) {
                    height = 0;
                } 
            }

            $form.css('height', height);
            setTimeout(() => {
                productHandler.wcSetSelectUI($($iframeBody));   
            }, 1000);
        });
    },

    setHeightIframe: function($form){
        let height  = $form.children().get(0).contentWindow.document.body.scrollHeight;
        $form.css('height', height);
    },

    getUrlParameter: function(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
    
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    },

    init: function(){
        var self = this;
        self.handlerEvents();
        productHandler.wcSetSelectUI();
        setTimeout(() => {
            productHandler.wcSetSelectUI();
        }, 500);

        if (self.getUrlParameter('save_status')) {
            parent.location.reload();
        }
    }
}